// Una entrada por zona. Cada zona es { en, es } y sus claves llevan el prefijo
// de la zona ("rack.", "auth."...), así que dos zonas no se pisan.
import common from './common';
import auth from './auth';
import account from './account';
import player from './player';
import audiotest from './audiotest';
import pip from './pip';
import rack from './rack';
import panels from './panels';
import assistant from './assistant';
import admin from './admin';
import tutorial from './tutorial';
import studio from './studio';

const LOCALES = [common, auth, account, player, audiotest, pip, rack, panels, assistant, admin, tutorial, studio];
export default LOCALES;
